<template>
  <a-select
    :options="displayRuleOptions"
    v-model.sync="localValue"
    :is-searchable="false"
    has-teleport>
  </a-select>
</template>

<script lang="ts">
  import Vue from "vue";
  import LocalValueEmissionMixin from "../../../mixins/localValueEmissionMixin";
  import {TargetTypeHelper} from "../../../models/conditionalRules/targetType";

  export default Vue.extend({
    props: ['value', 'targetTypes'],
    mixins: [LocalValueEmissionMixin],
    data() {
      return {
      }
    },
    computed: {
      displayRuleOptions(): Array<any> {
        return this.targetTypes.map(x => {
          return {
            value: x,
            label: TargetTypeHelper.getLabel(x)
          };
        });
      }
    },
    mounted(): void {
      if (this.value === null) {
        this.$emit('input', this.displayRuleOptions[0].value);
      }
    },
  });
</script>